/**
 * 全局常量、方法封装模块
 * 通过原型挂载到Vue属性
 * 通过 this.Global 调用
 */
// 后台管理系统服务器地址
export const baseUrl = process.env.NODE_ENV  === 'production' ? process.env.BASE_API : 'http://www.usze.net/news_information/'
// export const baseUrl = process.env.BASE_API
export default {
    baseUrl
}



// WEBPACK FOOTER //
// ./src/utils/global.js